import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

let isReloadingForUpdate = false;

declare global {
  interface Window {
    __pendingAppReload?: boolean;
  }
}

const shouldDeferReload = () => document.body.dataset.deferAppReload === 'true';

const reloadForUpdate = () => {
  if (isReloadingForUpdate) {
    return;
  }

  if (shouldDeferReload()) {
    window.__pendingAppReload = true;
    return;
  }

  isReloadingForUpdate = true;
  window.__pendingAppReload = false;
  window.location.reload();
};

const activateUpdatedServiceWorker = (registration: ServiceWorkerRegistration) => {
  const waitingWorker = registration.waiting;

  if (!waitingWorker) {
    return;
  }

  waitingWorker.postMessage({ type: 'SKIP_WAITING' });
};

navigator.serviceWorker?.addEventListener('controllerchange', reloadForUpdate);
window.addEventListener('app:reload-unblocked', reloadForUpdate);

// 서비스워커는 페이지를 새로 열 때만 새 버전을 확인한다.
// PWA 로 설치해 두고 쓰면 앱을 끄지 않는 한 그 확인이 일어나지 않아,
// 새로 배포한 화면을 며칠이고 못 보는 일이 생긴다.
// 그래서 앱이 앞으로 올 때와 일정 간격마다 직접 확인을 건다.
// 새 버전이 있으면 위의 onUpdate -> SKIP_WAITING -> controllerchange 순서로 이어진다.
const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;
const MIN_UPDATE_CHECK_GAP_MS = 60 * 1000;
let lastUpdateCheckAt = 0;

const checkForAppUpdate = async () => {
  if (!navigator.serviceWorker) {
    return;
  }

  // 탭 전환을 반복해도 확인 요청이 몰리지 않게 한다
  const now = Date.now();
  if (now - lastUpdateCheckAt < MIN_UPDATE_CHECK_GAP_MS) {
    return;
  }
  lastUpdateCheckAt = now;

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    await registration?.update();
  } catch (error) {
    // 확인에 실패해도 기존 화면은 그대로 쓰면 된다
    console.error('새 버전 확인 실패:', error);
  }
};

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    checkForAppUpdate();
  }
});
window.addEventListener('focus', checkForAppUpdate);
window.setInterval(() => {
  if (document.visibilityState === 'visible') {
    checkForAppUpdate();
  }
}, UPDATE_CHECK_INTERVAL_MS);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: activateUpdatedServiceWorker,
});
